export const path = {
  root: '/',
  resetPass: '/resetPass',
  contactLema: '/contactLema',
  unoChangeLog: '/unoChangeLog',
  analysis: {
    root: '/analysis',
    funds: '/analysis/funds',
    titles: '/analysis/titles',
    compareFunds: '/analysis/compareFunds',
    alm: '/analysis/alm',
    risk: {
      root: '/analysis/risk',
      market: '/analysis/risk/market',
      articles: '/analysis/risk/articles',
      benchmarks: '/analysis/risk/benchmarks',
      policy: '/analysis/risk/policy',
    },
    returns: {
      root: '/analysis/returns',
      daily: '/analysis/returns/daily',
      global: '/analysis/returns/global',
      assets: '/analysis/returns/assets',
      segregation: '/analysis/returns/segregation',
      articles: '/analysis/returns/articles',
      benchmark: '/analysis/returns/benchmark',
      classes: '/analysis/returns/classes',
    },
    curveXMarket: '/analysis/curveXMarket',
  },
  administration: {
    root: '/administration',
    client: {
      root: '/administration/client',
      details: {
        root: '/administration/client/details',
        newClient: '/administration/client/details/newClient',
        managers: '/administration/client/details/managers',
        submanagers: '/administration/client/details/submanagers',
        viewers: '/administration/client/details/viewers',
        investorProfile: '/administration/client/details/investorProfile',
        cadprev: '/administration/client/details/cadprev',
        gescon: '/administration/client/details/gescon',
        institutionRates: '/administration/client/details/institutionRates'
      }
    },
    clients: {
      root: '/administration/clients',
      all: '/administration/clients/all',
      closures: '/administration/clients/all/closures',
    },
    funds: {
      root: '/administration/funds',
      all: '/administration/funds/all',
      titles: '/administration/funds/titles',
    },
    advisor: {
      new: '/administration/newAdvisor'
    },
    logs: {
      root: '/administration/logs',
      comdinheiroReqs: '/administration/logs/comdinheiroReqs',
      clientUpdates: '/administration/logs/clientUpdates',
      actions: '/administration/logs/actions',
      accesses: '/administration/logs/accesses',
      conciliations: '/administration/logs/conciliations',
      portfolioChanges: '/administration/logs/portfolioChanges',
      usage: '/administration/logs/usage'
    },
    clientsRents: {
      root: '/administration/clientsRents'
    }
  },
  administrative: {
    root: '/administrative',
    tools: {
      root: '/administrative/tools',
      singlesAprs: '/administrative/tools/singleAprs',
      exportDB: '/administrative/tools/exportDB'
    },
    demonstratives: {
      root: '/administrative/demonstratives',
      funds: '/administrative/demonstratives/funds',
      xmlAssets: '/administrative/demonstratives/xmlAssets',
    },
    accounting: {
      root: '/administrative/accounting',
      returnsIPC14: '/administrative/accounting/returns',
      lossProvision: '/administrative/accounting/lossProvision',
    },
    videos: '/administrative/videos',
    filesAndDocuments: '/administrative/filesAndDocuments',
    accreditation: {
      root: '/administrative/accreditation',
      documentation: '/administrative/accreditation/documentation',
      manuals: '/administrative/accreditation/manuals',
      termsAndAttestations: '/administrative/accreditation/termsAndAttestations',
      accreditedInstitutions: '/administrative/accreditation/accreditedInstitutions',
      trademate: '/administrative/accreditation/trademate',
    },
    alocation: {
      root: '/administrative/alocation',
      assets: '/administrative/alocation/assets',
      benchmarks: '/administrative/alocation/benchmarks',
      articles: '/administrative/alocation/articles',
      annotations: '/administrative/alocation/annotations',
    },

  },
  registers: {
    statusClients: {
      root: '/registers/statusClients'
    },
    actuarysClients: {
      root: '/registers/actuarysClients'
    },
    marketing: {
      root: '/registers/marketing'
    }
  },
  investiments: {
    root: '/investiments',
    balancesCollect: '/transactions/balancesCollect',
    targets: '/investiments/targets'
  }
};

export const clientScreenAllowedPaths = {
  component: path.administration.clients.root,
  manager: path.administration.client.details.newClient,
  admin: path.administration.clients.all,
};

export const administrationFundsScreenPaths = {
  home: path.administration.funds.all
};
